// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing080({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/080/25012201.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/080/25012202.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/080/25012203.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton4.png`}
      qTitleColor="#0066ff"
      qOptionColor="blue"
      formFieldColor="white"
      companyName="본원"
      privacyCompanyName="청춘플란트치과의원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/dlatl.jpg`}
      eventDates={true}
    />
  );
}

export default Randing080;
